<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{path:'/'}">首页</el-breadcrumb-item>
      <el-breadcrumb-item>漂流瓶日志列表</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card class="box-card">
    <el-row :gutter="20">
      <el-text>名称：</el-text>
      <el-col :span="4">
        <el-input
          placeholder="请输入内容"       
          clearable
          v-model="txt1">
          </el-input>  
      </el-col>
      <el-row>
        <el-button @click="searchPage" :icon="search" circle>
          <el-icon><Search /></el-icon>
        </el-button>
      </el-row>
    </el-row>
    <!-- 新增、批量删除按钮 -->
    <el-row class="bt">
      <el-button type="primary" @click="addClick" v-if="false">+新增</el-button>
    </el-row>
    <!-- 管理列表 -->
    <el-table :data="tableData" style="width:100%">
      <el-table-column prop="wechatNum" label="微信号" />
      <el-table-column prop="nickname" label="获取人" />
      <el-table-column prop="driftBottleType" label="类型" />
      <el-table-column prop="driftBottleName" label="内容" />
      <el-table-column prop="addDate" label="获取日期" />
      <el-table-column prop="remark" label="备注" />
    </el-table>
    <div class="kh-page">
        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="[10, 20, 50, 100, 500]"
            :page-size="currentPageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="totalCount">
        </el-pagination>
    </div>
  </el-card>
</div>
</template>

  
<script>

  export default{
    data(){
      return {
        tableData : [],
        txt1: '',
        currentPage: 1,
        currentPageSize: 10,
        totalCount: 0
      }
    },
    mounted:function(){
      this.getPage()
    },
    methods:{
      //添加
      addClick(){
        this.$router.push("/Admin/DriftBottleLogsEdit")
      },
      getPage(){
        var ths = this
        var queryBO = {
          name: this.txt1,
          page: this.currentPage,
          pageSize: this.currentPageSize,
          sortField: ''
        }
        ths.$post('/DriftBottles/queryLogPage',queryBO)
        .then(function (res) { 
            if(res.success){
              ths.tableData = res.data.rows
              ths.totalCount = res.data.records
            }
        })
        .catch(function (err) {
          console.log(err)
        })    
      },
      handleEdit(row){
        this.$router.push("/Admin/DriftBottleLogsEdit?id="+row.id)
      },
      handleDelete(row){
        if(confirm("确定要删除吗？")){
          var ths = this
          ths.$get('/DriftBottleLogs/delete?id='+row.id)
          .then(function (res) { 
              alert(res.msg)
              if(res.success){
                ths.getPage()
              }
          })
          .catch(function (err) {
            console.log(err)
          })    
        }
      },
      handleSizeChange(val) {
        this.currentPageSize = val
        this.getPage()
      },
      handleCurrentChange(val) {
        this.currentPage = val
        this.getPage()
      },
      searchPage(){
        this.currentPage = 1
        this.getPage()
      }
    }
  }

</script>

<style>
.bt{
  padding:20px 0;
}
</style>